import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-mv-secondary text-gray-300 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <Link to="/" aria-label="MarketVyne home" className="inline-block">
            <Logo variant="full" height={36} />
          </Link>
          <p className="text-sm mt-4 max-w-sm text-gray-400">
            A vetted marketplace for SEO, web design, content & digital marketing — with transparent pricing
            and fair buyer/seller protection.
          </p>
        </div>
        <div>
          <div className="text-white font-bold mb-3 font-display">Marketplace</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/browse" className="hover:text-mv-accent">Browse services</Link></li>
            <li><Link to="/become-a-seller" className="hover:text-mv-accent">Become a seller</Link></li>
            <li><Link to="/how-it-works" className="hover:text-mv-accent">How it works</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-white font-bold mb-3 font-display">Support</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/how-it-works" className="hover:text-mv-accent">Buyer protection</Link></li>
            <li><Link to="/how-it-works" className="hover:text-mv-accent">Dispute policy</Link></li>
            <li><a className="hover:text-mv-accent" href="#">Terms</a></li>
            <li><a className="hover:text-mv-accent" href="#">Privacy</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 text-xs flex items-center justify-between text-gray-500">
          <span>© {new Date().getFullYear()} MarketVyne. All rights reserved.</span>
          <span className="hidden md:inline">Built with care for businesses that demand better outcomes.</span>
        </div>
      </div>
    </footer>
  );
}
